import { Icon, Text } from '@nexa/ui';

export interface FaqItemProps {
  readonly question: string;
  readonly answer: string;
}

/**
 * Một mục FAQ (`template.html:1031`).
 *
 * Giữ `<details>`/`<summary>` NATIVE (design doc §10.2): chạy được khi không có JS, và trạng thái
 * đóng/mở được screen reader đọc miễn phí. Đừng thay bằng state React — đổi lấy một accordion tự
 * viết là mất cả hai thứ đó.
 *
 * `list-none` + biến thể `::-webkit-details-marker` ẩn mũi tên mặc định của trình duyệt; thiết kế
 * thay nó bằng icon `plus` canh phải. Cần CẢ HAI: Firefox/Chrome mới nghe `list-style`, còn
 * WebKit cũ chỉ nghe pseudo-element riêng.
 *
 * Vùng bấm là cả `<summary>` — và nó cao **22.39** (đo trên bản build), KHÔNG đạt 44px của luật 6.
 * Pad 18/22 nằm trên `<details>`, không nằm trên `<summary>`: bản trước cộng nhầm pad của cha ra
 * "~54px" rồi kết luận không cần luật riêng cho mobile. Cả hai vế đều sai. Nợ này CHƯA vá, và
 * không cổng nào bắt được: rig chỉ quét thẻ liên kết và nút (`visual-matrix.mjs:277`), `summary`
 * nằm ngoài tập đo theo cấu tạo. Chiều RỘNG cũng chưa kiểm (vé #5) — đo tay.
 */
export function FaqItem({ question, answer }: FaqItemProps) {
  return (
    <details className="nx-disclose rounded-card-sm border border-ink-100 bg-surface px-[22px] py-[18px]">
      <summary className="flex cursor-pointer list-none items-center gap-3.5 text-title font-semibold text-ink-900 [&::-webkit-details-marker]:hidden">
        <span>{question}</span>
        <Icon name="plus" size={17} className="nx-disclose-mark ml-auto shrink-0 text-ink-400" />
      </summary>
      <Text size="body" className="mt-3">
        {answer}
      </Text>
    </details>
  );
}
